module.exports = __webpack_public_path__ + "static/media/cert_-2.e02d52ff.jpg";